<template>
	<div class="editProduct">
		<el-dialog title="编辑商品机制" width="30%" :visible.sync="dialogProductVisible" @close="resetForms('editForm')">
			<div class="product_box">
				<product-box :row="row" :tabName="tabName"></product-box>
			</div>
			<div class="user_info_box mt-10">
				<user-info-box :row="row"></user-info-box>
			</div>
			<div class="mt-20">
				<el-form :model="editForm" ref="editForm" :rules="editRules">
					<el-form-item label="直播价：" :label-width="formLabelWidth" prop="live_price">
						<el-input v-model="editForm['live_price']" autocomplete="off" placeholder="请输入" suffix-icon="suffix-icon live"></el-input>
					</el-form-item>
					<el-form-item label="佣金率：" :label-width="formLabelWidth" prop="commission_rate">
						<el-input v-model="editForm['commission_rate']" autocomplete="off" placeholder="请输入" suffix-icon="suffix-icon"></el-input>
					</el-form-item>
					<el-form-item label="服务费：" :label-width="formLabelWidth" prop="service_rate" v-if="$auth.hasPermi('system:goods-ServiceRate')">
						<el-input v-model="editForm['service_rate']" autocomplete="off" placeholder="请输入" suffix-icon="suffix-icon"></el-input>
					</el-form-item>
					<el-form-item label="规格：" :label-width="formLabelWidth" prop="spec">
						<el-input
							v-model="editForm['spec']"
							autocomplete="off"
							type="textarea"
							placeholder="规格一、规格二、规格三…"
							maxlength="255"
							show-word-limit
						></el-input>
					</el-form-item>
					<el-form-item label="赠品：" :label-width="formLabelWidth" prop="gifts">
						<el-input
							v-model="editForm['gifts']"
							autocomplete="off"
							type="textarea"
							placeholder="请输入赠品"
							maxlength="80"
							show-word-limit
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogProductVisible = false">取 消</el-button>
				<el-button type="primary" @click="editConfirm">确 定</el-button>
			</div>
		</el-dialog>
		<change ref="change" @refreshList="refreshList"></change>
	</div>
</template>
<script>
import change from './change.vue';
import productBox from '@/components/common/productBox';
import userInfoBox from '@/components/common/userInfoBox';
import { checkPriceReg } from '@/utils/validate';
import { affirmChange, editProduct } from '@/api/cooperationProgress';
import { mapGetters } from 'vuex';
export default {
	components: {
		productBox,
		userInfoBox,
		change,
	},
	data() {
		return {
			row: {},
			dialogProductVisible: false,
			formLabelWidth: '80px',
			editForm: {
				live_price: '',
				commission_rate: '',
				service_rate: '',
				spec: '',
				gifts: '',
			},
			editRules: {
				live_price: [{ required: true, validator: checkPriceReg, trigger: 'blur', msg: '请输入直播价' }],
				commission_rate: [{ required: true, validator: checkPriceReg, trigger: 'blur', msg: '请输入佣金率' }],
				service_rate: [{ required: true, validator: checkPriceReg, trigger: 'blur', msg: '请输入服务费率' }],
				spec: [{ required: true, message: '请输入规格', trigger: 'blur' }],
				gifts: [{ required: true, message: '请输入赠品', trigger: 'blur' }],
			},
			editFormBefore: {},
			changeArr: [],
			tabName: '0',
		};
	},
	methods: {
		initEditFun(row, tabName) {
			this.tabName = tabName;
			this.row = row;
			this.editForm.cooperate_id = row.cooperate_id;
			for (let key in this.editForm) {
				this.$set(this.editForm, key, row[key]);
			}
			this.editFormBefore = this.editForm;
			this.editFormBefore = JSON.parse(JSON.stringify(this.editForm));
			this.dialogProductVisible = true;
		},
		editConfirm() {
			this.$refs.editForm.validate(async valid => {
				if (valid) {
					for (var key in this.editFormBefore) {
						if (this.editFormBefore[key] != this.editForm[key] && key != 'service_rate') {
							this.changeArr.push({
								name: key === 'live_price' ? '直播价' : key === 'commission_rate' ? '佣金率' : key === 'spec' ? '规格' : '赠品',
								field: key,
							});
						}
					}
					if (!this.changeArr.length) {
						const { code } = await editProduct(this.editForm);
						if (code == 0) {
							this.$message.success('操作成功');
							this.$emit('refreshList');
							this.dialogProductVisible = false;
						}
					} else {
						this.$refs.change.initChange(this.editFormBefore, this.editForm, this.changeArr, this.row);
						setTimeout(() => {
							this.dialogProductVisible = false;
						}, 0);
					}
				}
			});
		},
		refreshList() {
			this.$emit('refreshList');
		},
		//重置弹框表单
		resetForms(from) {
			this.changeArr = [];
			// this.$refs[from].resetFields();
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .suffix-icon::after {
	content: '%';
	width: 33px;
	background-color: #f7f8fa;
	border-bottom-right-radius: 2px;
	border-top-right-radius: 2px;
}
/deep/ .live::after {
	content: '元';
}
/deep/ .el-input__suffix {
	height: 92%;
	right: 1px;
	top: -1px;
}
</style>
